import {createSvgIcon} from '../create-svg-icon';

export const ViewColumnIcon = createSvgIcon(
  <path d="M3 5v14h18V5H3zm5.33 12H5V7h3.33v10zm5.34 0h-3.33V7h3.33v10zM19 17h-3.33V7H19v10z" />
, 'ViewColumnOutlined');
